import moment from 'moment'
import store from 'app/store'
import { cacheActions } from 'core/caching/cacheReducers'
import { MessageTypes } from 'core/components/notifications/model'
import { permissionsActions } from 'core/session/permissionsReducers'
import { sessionActions } from 'core/session/sessionReducers'

export const SESSION_EXPIRY_WARNING_THRESHOLD = 120 // 2 minutes

/**
 * @description
 * Check if the session is about to expire and show a warning message.
 * Checks if the session is expired and show a warning message.
 * @param showToast - Function to show a toast message.
 * @returns {void}
 */
const sessionTimeoutCheck = (showToast: any) => (dispatch: any) => {
  const { session } = store.getState()
  const { expiresAt, showSessionExpiryWarning, sessionExpiryWarningDismissed } = session
  if (!expiresAt) return

  const now = moment()
  const expiryTime = moment(expiresAt)
  const timeUntilExpiry = expiryTime.diff(now, 'seconds')

  // Show warning 2 minutes (120 seconds) before expiry
  if (
    timeUntilExpiry <= SESSION_EXPIRY_WARNING_THRESHOLD &&
    timeUntilExpiry > 0 &&
    !showSessionExpiryWarning &&
    !sessionExpiryWarningDismissed
  ) {
    // Dispatch action to show session expiry modal
    dispatch(
      sessionActions.updateSession({
        showSessionExpiryWarning: true,
      }),
    )
  }

  // Check if session has expired
  const sessionExpired = moment().isAfter(expiresAt)
  if (sessionExpired) {
    dispatch(sessionActions.destroySession())
    dispatch(cacheActions.clearCache())
    dispatch(permissionsActions.clearPermissions())
    showToast('Your session has expired, please log in again', MessageTypes.warning, 5000, {
      vertical: 'top',
      horizontal: 'center',
    })
  }
}

export default sessionTimeoutCheck
